import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-upcoming-bills-modal',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './upcoming-bills-modal.html',
    styleUrl: './upcoming-bills-modal.scss'
})
export class UpcomingBillsModalComponent {
    @Input() isOpen: boolean = false;
    @Output() close = new EventEmitter<void>();

    minimumAmount: string = '100.00';
    quickAmounts: string[] = ['₹1,000.00', '₹10,000.00', '₹50,000.00'];

    onClose() {
        this.close.emit();
    }

    onSave() {

        this.close.emit();
    }

    setAmount(amount: string) {
        // Remove currency symbol and commas for the input
        this.minimumAmount = amount.replace(/[₹,]/g, '');
    }
}
